// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const natu: PokeData = {
  "id": 177,
  "name": "natu",
  "height": 2,
  "weight": 20,
  "base_experience": 64,
  "types": [
    PokeType.PSYCHIC,
    PokeType.FLYING
  ],
  "api_moves": [
    "leer",
    "peck",
    "psychic",
    "teleport",
    "night-shade",
    "confuse-ray",
    "future-sight",
    "wish",
    "miracle-eye",
    "psycho-shift",
    "lucky-chant",
    "me-first",
    "power-swap",
    "guard-swap",
    "ominous-wind",
    "stored-power"
  ],
  "moves": [
    "leer",
    "peck",
    "psychic",
    "night-shade",
    "confuse-ray",
    "future-sight",
    "zen-headbutt",
    "psy-pulse",
    "synchronize",
    "psychic-terrain",
    "sky-attack",
    "psy-ball",
    "prismatic-cage"
  ],
  "evolution_chain": {
    "id": 88,
    "item": null,
    "species": [
      {
        "name": "natu",
        "order": 206,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "xatu",
        "order": 207,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 177,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 42.5,
    "speed": 70,
    "ability_power": 70
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
